module.exports = __webpack_public_path__ + "img/ld-img-28@2x.e5976ef1.png";